import { OKELink, SANS_2, UI_BODY_SM_DF } from "oolib";
import React from "react";
import { stitchLink } from "../../../../../../utils/general";
import { useGetQueryData } from "../../../../../../utils/react-query-hooks/general";
import { resolveRoutePathFromGenerator } from "./TableLink_routePathGeneratorLookup";

const TableLink = ({
  value,
  to: toConfig,
  icon,
  tableRowData,
  typoComp = "UI_BODY_SM_DF",
  routePathGenerator,
}) => {
  let comps = { SANS_2, UI_BODY_SM_DF };
  let Comp = comps[typoComp];

  const { SELF_MANAGED_BASE_CONFIGS } = useGetQueryData("platformConfigs");

  const to = routePathGenerator
    ? resolveRoutePathFromGenerator({ routePathGenerator, tableRowData, SELF_MANAGED_BASE_CONFIGS })
    : stitchLink(tableRowData, toConfig);

  return (
    <Comp>
      <OKELink {...{ to, icon }}>{value}</OKELink>
    </Comp>
  );
};

export default TableLink;
